import styled, { css, keyframes } from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { FontWeight } from '../../../shared/constants/Fonts';
import {
  MediaQuery,
  Shadow,
  Transition,
} from '../../../shared/constants/Styles';
import { Typography } from '../../../shared/constants/Typographies';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const PictureContainer = styled.div`
  min-width: ${({ isHighlighted }) => isHighlighted && '330px'};
  width: ${({ isHighlighted }) => isHighlighted && '330px'};
  overflow: hidden;
  border-radius: 15px;
  background-color: ${Color.GHOST_WHITE};
  display: flex;
  align-items: center;
`;

export const TitleCard = styled.h3`
  ${({ isHighlighted }) =>
    isHighlighted ? Typography.XXL_BOLDER : Typography.XL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: ${({ isHighlighted }) => (isHighlighted ? '30px' : '10px')} 0px;
`;

export const Description = styled.p`
  ${Typography.M};
  margin: 16px 0px;
  font-weight: ${FontWeight.REGULAR};
  line-height: 24px;
  color: ${Color.DOLPHIN};
  height: 0;
  opacity: 0;
`;

export const BottomContainer = styled.div`
  display: flex;
  position: absolute;
  top: ${({ isHighlighted }) => (isHighlighted ? `273` : `295`)}px;
  width: 300px;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  position: absolute;
  top: 255px;
  height: 0;
  opacity: 0;
  width: 301px;

  a:not(:last-child),
  button:not(:last-child) {
    padding: 0px 10px;
  }

  ${MediaQuery.M_AND_DOWN} {
    display: flex;

    a,
    button {
      width: auto;
    }
  }
`;

export const DetailWrapper = styled.div`
  margin-left: 3px;

  a,
  button {
    padding: 0px 10px;
  }
`;

export const LikeWrapper = styled.div`
  margin-left: auto;
`;

export const AuthorWrapper = styled.div`
  display: flex;
  height: 0;
  opacity: 0;
  padding-top: 155px;
`;

const ThemeCard = css`
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: none;
  transition: ${Transition.ALL_EASE};
  text-decoration: none;
  position: relative;
  height: 330px;
  border-radius: 30px;
  padding: 30px;

  &:hover {
    background: ${Color.WHITE};
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: ${Shadow.BLUE_ACTIVE};

    ${AuthorWrapper} {
      animation: ${fadeIn} 0.5s ease-out;
      opacity: 1;
    }

    ${Description} {
      animation: ${fadeIn} 0.5s ease-out;
      opacity: 1;
      margin: 0px;
    }
  }

  ${MediaQuery.S_AND_DOWN} {
    padding: 20px;
  }
`;

export const Card = styled.div`
  ${ThemeCard};
  width: 360px;

  &:hover {
    ${PictureContainer} {
      height: 0;
      opacity: 0;
    }

    ${BottomContainer} {
      top: 215px;
      opacity: 0;
      height: 0;
    }

    ${ButtonContainer} {
      animation: ${fadeIn} 0.5s ease-out;
      opacity: 1;
    }

    ${TitleCard} {
      opacity: 0;
      height: 0px;
      margin: 0px;
    }
  }

  ${MediaQuery.S_AND_DOWN} {
    width: 350px;
  }
`;

export const QuestionCounter = styled.span`
  ${Typography.XXS};
  font-weight: ${FontWeight.BLACK};
  background-color: ${Color.ZIRCON};
  color: ${Color.BLUE_RIBBON};
  padding: 8px 12px 8px 12px;
  border-radius: 20px;
`;

export const AuthorTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 60px;
  justify-content: center;
`;

export const AuthorFullName = styled.span`
  ${Typography.S_BOLDER};
  color: ${Color.BLUE_BIG_STONE};
  margin-left: 7px;
`;

export const AuthorJob = styled.span`
  ${Typography.XXS};
  color: ${Color.DOLPHIN};
  margin-left: 7px;
`;

export const AuthorNameJobWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Author = styled.span`
  ${Typography.XXS_BOLDER};
  color: ${Color.BLUE_BIG_STONE};
  margin-left: 7px;
`;

export const AuthorCompany = styled.span`
  ${Typography.XXS};
  color: ${Color.DOLPHIN};
  margin-left: 7px;
  max-width: 140px;
`;

export const QuestionsLikesWrapper = styled.div`
  margin-left: auto;
  display: flex;

  & > :last-child {
    margin-left: 4px;
  }
`;

export const HorizontalCard = styled.div`
  ${ThemeCard};
  width: 720px;

  &:hover {
    ${ButtonContainer} {
      animation: ${fadeIn} 0.5s ease-out;
      opacity: 1;
    }

    ${TitleCard} {
      opacity: 0;
      height: 0px;
      margin: 0px;
    }

    ${BottomContainer} {
      top: 215px;
      opacity: 0;
      height: 0;
    }
  }

  ${MediaQuery.S_AND_DOWN} {
    width: 350px;
  }
`;

export const HorizontalWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const ContentContainer = styled.div`
  padding-left: 30px;
  max-width: 350px;
`;
